import { Injectable } from '@angular/core';
import {
    addShipmentsToTransportOrderType,
    addShipmentToTransportOrderType
} from '../../models/planningPageTypes';
import { environment } from 'apps/nagel-cal-disposition/environment/environment';
import {
    getTransportOrderLegEndpoint,
    getTransportOrderLegsEndpoint,
    getTransportOrderLotEndpoint,
    reorderLegsEndpoint,
    unassignLegsAndLotsEndpoint
} from '../configuration/consts/endpoints';
import { RequestService } from '@nagel-services';
import {
    AddLotToTransportOrderRequest,
    AddLotToTransportOrderResponse,
    AddShipmentsToTransportOrderTypeRequest,
    AddShipmentsToTransportOrderTypeResponse,
    AddShipmentToTransportOrderTypeRequest,
    AddShipmentToTransportOrderTypeResponse,
    ReorderAssignmentLegsRequest,
    UnassignLegsResponse
} from '../../models/assignmentsTypes';

const ONE_BASED_INDEX_OFFSET = 1;

@Injectable({
    providedIn: 'root'
})
export class AssignmentRequestsService {
    constructor(
        private requestService: RequestService
    ) { }

    addShipmentToTransportOrder(
        {
            legId,
            transportOrderId,
            destinationTourPointId,
            relationType
        }: addShipmentToTransportOrderType
    ) {
        const url = `${environment.apiUrl}${getTransportOrderLegEndpoint(transportOrderId, legId)}`;
        const requestPayload = {
            destinationTourPointId,
            relationType
        };

        return this.requestService.putRequest<AddShipmentToTransportOrderTypeRequest, AddShipmentToTransportOrderTypeResponse>(url, requestPayload, {}, true);
    }

    addShipmentsToTransportOrder(
        {
            legIds,
            transportOrderId,
            destinationTourPointId,
            relationType
        }: addShipmentsToTransportOrderType
    ) {
        const url = `${environment.apiUrl}${getTransportOrderLegsEndpoint(transportOrderId)}`;
        const requestPayload = {
            legIds,
            destinationTourPointId,
            relationType
        };

        return this.requestService.putRequest<AddShipmentsToTransportOrderTypeRequest, AddShipmentsToTransportOrderTypeResponse>(url, requestPayload, {}, true);
    }

    addLotToTransportOrder(
        lotId: string,
        transportOrderId: number,
        destinationTourPointId: number | null = null,
        relationType: number | null = null
    ) {
        const url = `${environment.apiUrl}${getTransportOrderLotEndpoint(transportOrderId, lotId)}`;
        const requestPayload = {
            destinationTourPointId,
            relationType
        };

        return this.requestService.putRequest<AddLotToTransportOrderRequest, AddLotToTransportOrderResponse>(url, requestPayload, {}, true);
    }

    reorderAssignmentLegs(
        transportOrderId: number,
        legId: string,
        newOrder: number
    ) {
        const url = `${environment.apiUrl}${reorderLegsEndpoint}`;
        const requestPayload = {
            TransportOrderId: transportOrderId,
            LegId: legId,
            NewOrder: newOrder + ONE_BASED_INDEX_OFFSET
        };

        return this.requestService.putRequest<ReorderAssignmentLegsRequest, unknown>(url, requestPayload);
    }

    unassignLegsAndLotsFromTransportOrder(
        selectedLegIds: string[],
        transportOrderId: number
    ) {
        const url = `${environment.apiUrl}${unassignLegsAndLotsEndpoint}`;

        const requestPayload = {
            LegIds: selectedLegIds,
            TransportOrderId: transportOrderId
        };

        return this.requestService.putRequest<unknown, UnassignLegsResponse >(url, requestPayload);
    }
}